import { getQueryParam } from './page/funds-page';

export default class ViewsExposed {
  init() {
    ViewsExposed.initAjaxHandler();
    ViewsExposed.initBrowserNavigationHandler();
    ViewsExposed.initUrlMonitor();
  }

  static locationSearch = window.location.search;

  static initAjaxHandler() {
    jQuery(document).on('ajaxSend', (event, jqXHR, ajaxOptions) => {
      if (typeof ajaxOptions.type !== 'undefined' && ajaxOptions.type.toUpperCase() === 'GET') {
        ajaxOptions.url = ViewsExposed.addPageUrl(ajaxOptions.url);
      } else if (typeof ajaxOptions.data === 'string') {
        ajaxOptions.data = ViewsExposed.addPageUrl(ajaxOptions.data);
      }
    });
  }

  static addPageUrl(property) {
    const keys = ['view_display_id', '_drupal_ajax'];

    for (let i = 0; i < keys.length; i++) {
      if (property.indexOf(keys[i]) !== -1) {
        return property + '&parent_page_url=' + window.location.pathname;
      }
    }

    return property;
  }

  static initBrowserNavigationHandler() {
    window.addEventListener('popstate', () => {
      if (window.location.search === ViewsExposed.locationSearch) {
        return;
      }

      const filters = jQuery('form.views-exposed-form').find('select');

      filters.each(function () {
        const filter = jQuery(this);
        const name = filter.attr('name');
        const queryValue = decodeURI((getQueryParam(name) || '').replace(/\+/g, ' '));

        filter.val(queryValue);
      });

      filters.first().trigger('change');
    });
  }

  static initUrlMonitor() {
    jQuery(document).on('location-change', (event, newUrl) => {
      ViewsExposed.locationSearch = newUrl.indexOf('?') === -1 ? '' : newUrl.match(/\?.+/)[0];
    });
    window.addEventListener(
      'hashchange',
      () => {
        if (window.location.hash === '') {
          window.location.replace('#');
          history.replaceState({}, '', window.location.href.slice(0, -1));
        }
      },
      false,
    );
  }
}
